export const ABORTED = 'aborted';
export const BLOCKED = 'blocked';
export const CALLCENTER_KO = 'callCenterKO';
export const CODEC_ERROR = 'codecError';
export const COMPLETED = 'completed';
export const CONNECT_ERROR = 'connectError';
export const DEFINITE_KO = 'definiteKO';
export const EXPIRED_DOCUMENT = 'expiredDocument';
export const LOW_QUALITY = 'loqQuality';
export const NON_EXCLUSIVE = 'nonExclusive';
export const PROGRAMMED = 'programmed';
export const START = 'start';
export const WAITING = 'waiting';
export const WRONG_FACE_MATCH = 'wrongFaceMatch';
export const WRONG_PERMISSIONS = 'wrongPermissions';
export const BLURRED = 'blurred';
export const CAMERA_ERROR = 'cameraError';
export const SCREEN_PRINT_ERROR = 'screenPrintError';
export const LIFE_PROOF_ERROR = 'lifeProofError';
export const INVALID_DOCUMENT = 'invalidDocument';
export const NETWORK_ERROR = 'networkError';
export const QR_ERROR = 'qrError';
export const DETECTION_TIMEOUT = 'detectionTimeout';
export const TOKEN_NOT_ALLOWED = 'tokenNotAllowed';

export const ERROR = 'error';
export const LEAVE = 'leave';
